// extracted by mini-css-extract-plugin
export default {"pageHeader":"styles_pageHeader__Crjq8","headerContainer":"styles_headerContainer__gczGY"};